import { StyleSheet } from 'react-native'
import type { Theme } from '../../../src/theme/getTheme'

export const getKnockoutViewStyles = (theme: Theme) =>
  StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: theme.background.primary,
    },
    // Full width: the knockout bracket spans the whole screen on big devices rather than being
    // boxed into a narrow centred column (the bracket itself scrolls horizontally when needed).
    content: {
      paddingHorizontal: 16,
      paddingTop: 14,
      paddingBottom: 40,
    },
  })
